"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiColumnGrid = MultiColumnGrid;
exports.default = MultiColumn;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = require("@linaria/react");
var _core = require("@linaria/core");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = _interopRequireDefault(require("react"));
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _index2 = _interopRequireDefault(require("../../../elements/other/section-item/index.js"));
var _multiColumnItem = _interopRequireDefault(require("../../../elements/other/multi-column-item"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
/** @module MultiColumn */

// TODO: Use color variable for border
const MultiColumnGridComponent = /*#__PURE__*/(0, _react.styled)("div")({
  name: "MultiColumnGridComponent",
  class: "pl-mtlkc2j",
  vars: {
    "mtlkc2j-1": [({
      align
    }) => align === 'start' ? 'flex-start' : `${align}`],
    "mtlkc2j-3": [({
      tabletColumns
    }) => `repeat(${tabletColumns}, minmax(200px, 1fr))`],
    "mtlkc2j-4": [({
      tabletRows
    }) => tabletRows],
    "mtlkc2j-6": [({
      columns
    }) => `repeat(${columns}, minmax(200px, 1fr))`],
    "mtlkc2j-7": [({
      rows
    }) => rows]
  }
});
const gridLineStyles = "pl-g19gho5o";
const separatedStyles = "pl-s1o6iqwv";
function createGridRows(rowCount) {
  let templateRows = ``;
  for (let i = 1; i <= rowCount; i++) {
    // The number of names including the spacers [sp-*] must be set as the innerRowCount when adding a subcomponent
    templateRows += `[sp-${i}] calc(2vh + 0.5rem)
      [im-${i}] auto [tg-${i}] auto [eb-${i}] auto [hl-${i}] auto [ds-${i}] auto [hls-${i}] auto
      [pl-${i}] auto [cs-${i}] auto [ad-${i}] auto [di-${i}] auto
      [sp2-${i}] calc(2vh + 0.5rem)`;
  }
  return templateRows;
}

/**
 * Render MultiColumnGrid Component
 *
 * @param {Object} props React props
 * @param {Array} [props.items] Array of MultiColumnItems
 * @param {number} props.columns Number of columns
 * @param {boolean} props.gridlines Boolean for gridlines
 * @param {boolean} props.separated Boolean for separation
 * @param {string} props.align Item alignment
 * @param {Object} props.priceLockup Price Lockup
 * @returns {React.ReactElement} MultiColumn element
 * @public
 */

function MultiColumnGrid({
  items,
  columns = 2,
  gridlines,
  separated,
  align,
  ...props
}) {
  const childCount = items?.length || 0;
  columns = Math.min(columns, childCount);
  const innerRowCount = 12;
  const tabletColumns = childCount % 2 === 0 ? 2 : 1;
  const tabletRowCount = Math.ceil(childCount / tabletColumns);
  const rowCount = Math.ceil(childCount / columns);
  const tabletRows = createGridRows(tabletRowCount);
  const rows = createGridRows(rowCount);
  return /*#__PURE__*/_react2.default.createElement(MultiColumnGridComponent, (0, _extends2.default)({
    "data-cy": "multi-column-grid",
    tabletColumns: tabletColumns,
    columns: columns,
    align: align,
    tabletRows: tabletRows,
    rows: rows,
    className: `${gridlines && gridLineStyles} ${separated && separatedStyles}`
  }, props), /* eslint-disable max-statements */
  items?.map((item, i) => {
    const {
      id,
      rounded,
      indented,
      textAlign,
      backgroundColor,
      image,
      imgType,
      priceLockup,
      ...cardProps
    } = item;
    const tabletRow = Math.ceil((i + 1) / tabletColumns);
    const row = Math.ceil((i + 1) / columns);
    let tabletColumn = i + 1;
    let column = i + 1;
    let tabletRowStart = tabletRow;
    let tabletRowEnd = tabletRow + innerRowCount;
    let rowStart = row;
    let rowEnd = row + innerRowCount;
    if (tabletRow > 1) {
      tabletColumn -= (tabletRow - 1) * tabletColumns;
      tabletRowStart = (tabletRow - 1) * innerRowCount + 1;
      tabletRowEnd = tabletRowStart + innerRowCount;
    }
    if (row > 1) {
      column -= (row - 1) * columns;
      rowStart = (row - 1) * innerRowCount + 1;
      rowEnd = rowStart + innerRowCount;
    }
    return /*#__PURE__*/_react2.default.createElement(_multiColumnItem.default, {
      key: i,
      id: id,
      "data-cy": "item",
      textAlign: align || textAlign,
      rounded: rounded,
      indented: indented,
      backgroundColor: backgroundColor,
      image: image,
      imgType: imgType,
      card: cardProps,
      priceLockup: priceLockup,
      gridlines: gridlines,
      noPadding: columns === 1,
      gridSettings: {
        tabletColumn: tabletColumn,
        tabletRow: tabletRow,
        tabletRowStart: tabletRowStart,
        tabletRowEnd: tabletRowEnd,
        column: column,
        row: row,
        rowStart: rowStart,
        rowEnd: rowEnd
      }
    });
  }));
}
MultiColumnGrid.propTypes = {
  _name: _propTypes.default.string,
  items: _propTypes.default.arrayOf(_propTypes.default.shape(_multiColumnItem.default.propTypes)),
  columns: _propTypes.default.number,
  gridlines: _propTypes.default.bool,
  separated: _propTypes.default.bool,
  align: _propTypes.default.oneOf(['center', 'start'])
};

/* eslint-disable no-nested-ternary */
const MultiColumnWrapper = /*#__PURE__*/(0, _react.styled)("div")({
  name: "MultiColumnWrapper",
  class: "pl-m5uvuwv",
  vars: {
    "m5uvuwv-0": [({
      backgroundColor
    }) => backgroundColor]
  }
});

/**
 * Render MultiColumn Component
 * @memberof module:MultiColumn
 *
 * @param {Object} props React props
 * @param {Array} [props.items] Array of MultiColumnItems
 * @param {Number} props.columns Number of columns
 * @param {Boolean} props.gridlines Boolean for gridlines
 * @param {Boolean} props.separated Boolean for separation
 * @param {String} props.backgroundColor Background color
 * @param {Boolean} props.invert Invert text color
 * @param {String} props.partial Theme partial
 * @param {String} props.textAlign Text alignment
 * @param {String} props.align Item alignment
 * @param {String} props.verticalMargin Vertical margin spacing
 * @returns {React.ReactElement} MultiColumn element
 * @public
 */

function MultiColumn({
  _name,
  items,
  columns = 2,
  gridlines,
  separated,
  backgroundColor,
  align = 'center',
  textAlign = 'center',
  invert = false,
  partial,
  verticalMargin = 'none',
  ...headlineProps
}) {
  const parentName = 'multi-column';
  const {
    eyebrow,
    eyebrowTag = 'h2',
    headlineTag,
    ...headlineRest
  } = headlineProps;
  return /*#__PURE__*/_react2.default.createElement(_section.default, {
    dataCy: `${parentName}-section`,
    _name: _name,
    backgroundColor: (0, _patternLibraryUtils.getBackgroundColor)(backgroundColor),
    verticalMargin: verticalMargin,
    partial: partial || (invert ? 'dark1' : '')
  }, /*#__PURE__*/_react2.default.createElement(MultiColumnWrapper, null, (headlineProps?.eyebrow || headlineProps?.heading || headlineProps?.description) && /*#__PURE__*/_react2.default.createElement(_index2.default, {
    "data-cy": "content-item",
    rounded: false
  }, /*#__PURE__*/_react2.default.createElement(_index.default, (0, _extends2.default)({
    eyebrow: eyebrow,
    eyebrowTag: eyebrowTag,
    headlineTag: headlineTag || (eyebrow ? 'h3' : 'h2'),
    textAlign: textAlign
  }, headlineRest))), items && /*#__PURE__*/_react2.default.createElement(MultiColumnGrid, {
    align: align,
    items: items,
    columns: columns,
    gridlines: gridlines,
    separated: separated
  })));
}
MultiColumn.propTypes = {
  _name: _propTypes.default.string,
  items: _propTypes.default.arrayOf(_propTypes.default.shape(_multiColumnItem.default.propTypes)),
  columns: _propTypes.default.number,
  gridlines: _propTypes.default.bool,
  separated: _propTypes.default.bool,
  backgroundColor: _propTypes.default.oneOfType([_propTypes.default.shape({
    rgb: _propTypes.default.string,
    contrastRgb: _propTypes.default.string
  }), _propTypes.default.shape({
    intent: _propTypes.default.string
  })]),
  invert: _propTypes.default.bool,
  partial: _propTypes.default.string,
  textAlign: _propTypes.default.oneOf(['start', 'center']),
  align: _propTypes.default.oneOf(['start', 'center']),
  ..._patternLibraryUtils.marginProps,
  ..._index.default.propTypes
};